/**
 * 카메라/갤러리 hidden file input 공통 컴포넌트
 * useFileCapture hook과 함께 사용
 */

import type { RefObject } from "react";

interface HiddenFileInputsProps {
  cameraInputRef: RefObject<HTMLInputElement | null>;
  galleryInputRef: RefObject<HTMLInputElement | null>;
  onFileChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  /** 갤러리 input에서 다중 선택 허용 여부 (기본: false) */
  galleryMultiple?: boolean;
}

export function HiddenFileInputs({
  cameraInputRef,
  galleryInputRef,
  onFileChange,
  galleryMultiple = false,
}: HiddenFileInputsProps) {
  return (
    <>
      <input
        ref={cameraInputRef}
        type="file"
        accept="image/*"
        capture="environment"
        onChange={onFileChange}
        className="hidden"
      />
      <input
        ref={galleryInputRef}
        type="file"
        accept="image/*"
        multiple={galleryMultiple}
        onChange={onFileChange}
        className="hidden"
      />
    </>
  );
}
